import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';

import { GasTagComponent } from './gas-tag/gas-tag.component';
import { GasTagsComponent } from './gas-tags/gas-tags.component';

const COMPONENTS = [
  GasTagComponent,
  GasTagsComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
  ],
})
export class GasTagsModule {}
